export const OpenMapToken = '69002fcf63566f2396643824536f3d9b';
